export const sizes = {
    laptop: 1024,
    laptopL: 1440,
    desktop: 2560,
};

export const device = {
    laptop: `(min-width: ${sizes.laptop}px)`,
    laptopL: `(min-width: ${sizes.laptopL}px)`,
    desktop: `(min-width: ${sizes.desktop}px)`,
};

export const handleHideDropdown = (elementId: string) => {
    const currentDropdown = document.getElementById(elementId);
    if (currentDropdown) {
        currentDropdown.classList.remove("show");
    }
}

export const handleToggleDropdown = (elementId: string, boundingParentId?: string) => {
    const currentDropdown = document.getElementById(elementId);
    if (!currentDropdown) {
        return;
    }

    currentDropdown.classList.toggle("show");

    const currentDropdownRect = currentDropdown.getBoundingClientRect();
    if (currentDropdownRect.left === 0 && currentDropdownRect.right === 0) {
        return;
    }

    const boundingParent = boundingParentId ? document.getElementById(boundingParentId) : undefined;
    const topBoundary = boundingParent ? boundingParent.getBoundingClientRect().top : 0;
    const bottomBoundary = boundingParent ? boundingParent.getBoundingClientRect().bottom : window.innerHeight;
    const leftBoundary = boundingParent ? boundingParent.getBoundingClientRect().left : 0;
    const rightBoundary = boundingParent ? boundingParent.getBoundingClientRect().right : window.innerWidth;

    const bottomOverflow = currentDropdownRect.bottom - bottomBoundary;
    if (bottomOverflow > 0) {
        const topAdjustment = bottomOverflow + 16;
        const leftAdjustment = currentDropdownRect.width;
        if (currentDropdownRect.top - topAdjustment >= topBoundary && currentDropdownRect.left - leftAdjustment >= leftBoundary) {
            currentDropdown.style.marginTop = `-${topAdjustment}px`;
            currentDropdown.style.marginLeft = `-${leftAdjustment}px`;
            return;
        }
    }

    const currentDropdownLeftOverflow = currentDropdownRect.left;
    if (currentDropdownLeftOverflow < leftBoundary) {
        currentDropdown.style.marginRight = `-${Math.abs(currentDropdownLeftOverflow) + 16}px`;
        return;
    }

    const currentDropdownRightOverflow = rightBoundary - currentDropdownRect.right;
    if (currentDropdownRightOverflow < 0) {
        currentDropdown.style.marginLeft = `-${Math.abs(currentDropdownRightOverflow) + 16}px`;
    }
}

export const hexToRgb = (hex: string) => {
    const trimmedOutHash = hex.slice(1);
    const bigint = parseInt(trimmedOutHash, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgb(${r}, ${g}, ${b})`;
}

